import React, { useState } from "react";
import ProductForm from "./ProductForm";
import { BeerFormState } from "../../../constants/types";
import axios from "axios";
import Breadcrumbs from "../../../common/Breadcrumbs";
import { createProductService } from "../../../service/productService";
import { useNavigate } from "react-router-dom";
import Toast from "../../../common/Toast";

const CreateNewProduct: React.FC = () => {
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId");

  const handleSubmit = async (data: BeerFormState) => {
    setError(false);
    try {
      const response = await createProductService(data);
      if (response?.message === "Product created successfully")
        setToastMessage("Product details have been successfully added");
      else {
        setToastMessage("Failed to add product details. Please try again");
        setError(true);
      }
      setShowToast(true);
      setTimeout(() => {
        !error && navigate(`/${orgId}/seller/products`);
      }, 2000);
    } catch (error) {
      setToastMessage("Failed to add product details. Please try again");

      if (axios.isAxiosError(error)) {
        console.error(
          "Error creating product:",
          error.response?.data || error.message
        );
      } else {
        console.error("Unexpected error:", error);
      }
      setError(true);
      setShowToast(true);
    }
  };

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [error, setError] = useState(false);

  return (
    <div>
      <Breadcrumbs
        paths={["Products", "Create New Product"]}
        links={["/seller/products", "/seller/create-new-product"]}
      />

      <Toast
        setShowToast={setShowToast}
        showToast={showToast}
        toastMessage={toastMessage}
        error={error}
      />

      <ProductForm
        formTitle="Create New Product"
        buttonTextOne="Create"
        buttonTextTwo="Reset"
        beerName=""
        description=""
        price=""
        fileUpload={[]}
        quantity=""
        onSubmit={handleSubmit}
        existingImages={[]}
        isEdit={false}
        abv=""
        ibu=""
      />
    </div>
  );
};

export default CreateNewProduct;
